module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "jobs-area section-padding"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.productList), function(v, i) {
    return _c('div', {
      key: i,
      staticClass: "col-lg-12",
      attrs: {
        "id": "square"
      }
    }, [_c('div', {
      staticClass: "single-job mb-4 d-lg-flex justify-content-between fadeInUp animated"
    }, [_c('div', {
      staticClass: "job-text"
    }, [_c('h4', [_vm._v(_vm._s(v.name))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(v.description))])]), _vm._v(" "), _vm._m(0, true)])])
  }), 0)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "job-img align-self-center"
  }, [_c('img', {
    attrs: {
      "src": "static/assets/images/job1.png",
      "alt": "job"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f3bc67e8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/WareProduct.vue
// module id = 34
// module chunks = 0